import { Injectable } from '@angular/core';
import { ApiService } from '../api/api.service';

@Injectable({
  providedIn: 'root'
})
export class GameService {

  constructor(
    private apiService: ApiService
  ) { }
  
  getUrlPreview(){
    return this.apiService.getDomain() + "storage/vistaprevia/";
  }
  getUrlJuego(){
    return this.apiService.getDomain() + "storage/games/";
  }

  createGames(token, type) {
    return this.apiService.createGame(token, type);
  }

  listGames(token) {
    return this.apiService.getListGames(token);
  }

  duplicateGame(token, type) {
    return this.apiService.cloneGame(token, type);
  }

  eliminarGame(token, type) {
    return this.apiService.deleteGame(token, type);
  }

  designGeneral(token, id) {
    return this.apiService.getDesignGeneral(token, id);
  }

  fonts(token) {
    return this.apiService.getFonts(token);
  }

  styleFonts(token) {
    return this.apiService.getStyleFonts(token);
  }

  sizeFonts(token) {
    return this.apiService.getSizeFonts(token);
  }

  updateLayoutGeneralGame(token, idGame, data) {
    return this.apiService.updateDesignGeneral(token, idGame, data);
  }

  updateFondoImageGeneralGame(token, idGame, formdata) {
    return this.apiService.updateFondoDesignGeneral(token, idGame, formdata);
  }

  updateTipoFondoImageGeneralGame(token, idGame, data) {
    return this.apiService.updateTipoFondoDesignGeneral(token, idGame, data);
  }

  getListModelosbotones(token) {
    return this.apiService.getGalleryButtonModelo(token);
  }

  getListTemabotones(token, idModelo) {
    return this.apiService.getGalleryButtonTema(token, idModelo);
  }

  getListModelosbotonesRetro(token) {
    return this.apiService.getGalleryButtonModeloRetro(token);
  }

  getListTemabotonesRetro(token, idModelo) {
    return this.apiService.getGalleryButtonTemaRetro(token, idModelo);
  }

  updateModeloBoton(token, idGame, data) {
    return this.apiService.updateBotonModelo(token, idGame, data);
  }

  updateModeloBotonRetro(token, idGame, data) {
    return this.apiService.updateBotonModeloRetro(token, idGame, data);
  }

  // SPLASH

  getDataSplash(token, id) {
    return this.apiService.getSplash(token, id);
  }

  listIcons(token) {
    return this.apiService.getIcons(token);
  }

  updateSplashCampos(token, idGame, data) {
    return this.apiService.updateCampoSplash(token, idGame, data);
  }

  updateSplashTipoFondo(token, idGame, data) {
    return this.apiService.updateSplashTipoFondo(token, idGame, data);
  }

  updateSplashTipoFondoImage(token, idGame, formdata) {
    return this.apiService.updateSplashImageFondo(token, idGame, formdata);
  }

  updateSplashTipoLogo(token, idGame, data) {
    return this.apiService.updateSplashTipoLogo(token, idGame, data);
  }

  updateSplashLogoImage(token, idGame, formdata) {
    return this.apiService.updateSplashImageLogo(token, idGame, formdata);
  }

  updateSplashTipoIconoCarga(token, idGame, data) {
    return this.apiService.updateSplashTipoIcono(token, idGame, data);
  }

  updateSplashIconoCarga(token, idGame, data) {
    return this.apiService.updateSplashIcono(token, idGame, data);
  }

  // START
  getDataStart(token, id) {
    return this.apiService.getStart(token, id);
  }
  updateStartTipoFondo(token, idGame, data) {
    return this.apiService.updateStartTipoFondo(token, idGame, data);
  }

  updateStartTipoFondoImage(token, idGame, formdata) {
    return this.apiService.updateStartImageFondo(token, idGame, formdata);
  }

  updateStartCampos(token, idGame, data) {
    return this.apiService.updateCampoStart(token, idGame, data);
  }

  updateStartTipoLogo(token, idGame, data) {
    return this.apiService.updateStartTipoLogo(token, idGame, data);
  }

  updateStartLogoImage(token, idGame, formdata) {
    return this.apiService.updateStartImageLogo(token, idGame, formdata);
  }

  updateStartMetodology(token, idGame, data) {
    return this.apiService.updateStartStatusMetodology(token, idGame, data);
  }

  updateStartCredits(token, idGame, data) {
    return this.apiService.updateStartStatusCredits(token, idGame, data);
  }

  updateStartNews(token, idGame, data) {
    return this.apiService.updateStartStatusNews(token, idGame, data);
  }

  updateStartRed(token, idGame, data) {
    return this.apiService.updateStartRedes(token, idGame, data);
  }

  updateStartRedEstado(token, idGame, data) {
    return this.apiService.updateStartStatusRedes(token, idGame, data);
  }

  // SCREEN GAME
  getDataScreen(token, id) {
    return this.apiService.getScreen(token, id);
  }

  updateScreenCampos(token, idGame, data) {
    return this.apiService.updateCampoScreen(token, idGame, data);
  }

  getListaEstilosMarco(token) {
    return this.apiService.getListMarcoStyle(token);
  }

  getListaIconografias(token) {
    return this.apiService.getListIconografias(token);
  }

  getListaEstilosFondo(token) {
    return this.apiService.getListFondoStyle(token);
  }  
  getListaEstilosFondoColores(token,idModelo) {
    return this.apiService.getListaEstilosFondoColores(token, idModelo);
  }


  updateEstiloMarco(token, idGame, data) {
    return this.apiService.updateMarcoStyle(token, idGame, data);
  }

  updateIconografia(token, idGame, data) {
    return this.apiService.updateIconografias(token, idGame, data);
  }

  updateEstiloFondo(token, idGame, data) {
    return this.apiService.updateFondoStyle(token, idGame, data);
  }

  // MODAL GAME
  getDataModal(token, id) {
    return this.apiService.getModal(token, id);
  }

  updateModalCampos(token, idGame, data) {
    return this.apiService.updateCampoModal(token, idGame, data);
  }

  // METODOLOGIA GAME
  getDataMetodologia(token, id) {
    return this.apiService.getMetodology(token, id);
  }

  updateMetodologiaCampos(token, idGame, data) {
    return this.apiService.updateCampoMetodology(token, idGame, data);
  }

  updateMetodologiaImage(token, idGame, formdata) {
    return this.apiService.updateMetodologyImage(token, idGame, formdata);
  }

  // CREDITOS GAME
  getDataCreditos(token, id) {
    return this.apiService.getCredits(token, id);
  }

  updateCreditosCampos(token, idGame, data) {
    return this.apiService.updateCampoCredits(token, idGame, data);
  }

  updateCreditosImage(token, idGame, formdata) {
    return this.apiService.updateCreditsImage(token, idGame, formdata);
  }

  // REPORTAJES GAME
  getDataReportajes(token, id) {
    return this.apiService.getReports(token, id);
  }

  updateReportajesCampos(token, idGame, data) {
    return this.apiService.updateCampoReports(token, idGame, data);
  }

  // ESCENAS LISTADO
  getScenes(token, id) {
    return this.apiService.getScenes(token, id);
  }
  getCreateScenes(token, id) {
    return this.apiService.getCreateScenes(token, id);
  }
  duplicateScenes(token, id) {
    return this.apiService.duplicateScenes(token, id);
  }
  deleteScene(token, id){
    return this.apiService.deleteSceneHistory(token, id);
  }

  //AVATARES LISTADO PERSONAJES
  getCharactaresScenes(token, id) {
    return this.apiService.getCharactaresScenes(token, id);
  }
  createCharactaresGallery(token, id, body) {
    return this.apiService.createCharactaresGallery(token, id, body);
  }
  createCharacterFile(token, id, formdata) {
    return this.apiService.createCharacterFile(token, id, formdata);
  }
  //FONDOS DE ESCENAS
  getBackgroundsScenes(token, id) {
    return this.apiService.getBackgroundsScenes(token, id);
  }
  deleteBackgrounds(token, type) {
    return this.apiService.deleteBackgrounds(token, type);
  }
  createBackgroundsGallery(token, id, body) {
    return this.apiService.createBackgroundsGallery(token, id, body);
  }
  createBackgroundFile(token, id, formdata) {
    return this.apiService.createBackgroundFile(token, id, formdata);
  }
  updateNameFondo(token, id, body) {
    return this.apiService.updateNameFondoEscene(token, id, body);
  }
  //SOUNDTRACKS
  getSoundtracksScenes(token, id) {
    return this.apiService.getSoundtracksScenes(token, id);
  }
  deleteSoundtracks(token, type) {
    return this.apiService.deleteSoundtracks(token, type);
  }
  createSoundtracksGallery(token, id, body) {
    return this.apiService.createSoundtracksGallery(token, id, body);
  }
  createSoundtracksGeneralGallery(token, id, body) {
    return this.apiService.createSoundtracksGeneralGallery(token, id, body);
  }

  createSoundtracksFile(token, id, formdata) {
    return this.apiService.createSoundtracksFile(token, id, formdata);
  }
  createSoundtracksGeneralFile(token, id, formdata) {
    return this.apiService.createSoundtracksGeneralFile(token, id, formdata);
  }
  updateNameSoundtrack(token, id, body) {
    return this.apiService.updateNameSoundtrackEscene(token, id, body);
  }




  //GALERIA SOUNDTRACKS
  getSoundtracksGallery(token, data) {
    return this.apiService.getSoundtracksGallery(token, data);
  }
  getInfoGame(token, id) {
    return this.apiService.getInfoGame(token, id);
  }





  //GALERRIA AVATARES & BG & AUDIOS
  getCharactaresGalleryScenes(token, data) {
    return this.apiService.getCharactaresGalleryScenes(token, data);
  }
  //FONDOS GALERIA
  getBackgroundsGalleryScenes(token, data) {
    return this.apiService.getBackgroundsGalleryScenes(token, data);
  }

  eliminarCharactares(token, type) {
    return this.apiService.deleteCharactares(token, type);
  }
  getBgGalleryScenes(token, id) {
    return this.apiService.getBgGalleryScenes(token, id);
  }
  getSoundtracks(token, id) {
    return this.apiService.getSoundtracks(token, id);
  }
  
  getStatesAvatars(token, idAvatar) {
    return this.apiService.getStatesAvatars(token, idAvatar);
  }
  updateStatesAvatar(token, idAvatar, body) {
    return this.apiService.updateStatesAvatar(token, idAvatar, body);
  }
  deleteStatesAvatar(token, idState) {
    return this.apiService.deleteStatesAvatar(token, idState);
  }


  //Crear Accion de tipo dialogo
  createDialog(token, idDialog, data) {
    return this.apiService.createDialog(token, idDialog, data);
  }
  createDialogQuestion(token, idDialog, data) {
    return this.apiService.createDialogQuestion(token, idDialog, data);
  }
  createDialogImage(token, idDialog, data) {
    return this.apiService.createDialogImage(token, idDialog, data);
  }
  createDialogVideo(token, idDialog, data) {
    return this.apiService.createDialogVideo(token, idDialog, data);
  }
  createDialogAudio(token, idDialog, data) {
    return this.apiService.createDialogAudio(token, idDialog, data);
  }
  createDialogFinal(token, idDialog, data) {
    return this.apiService.createDialogFinal(token, idDialog, data);
  }

  getDialogs(token, idDialog) {
    return this.apiService.getDialogs(token, idDialog);
  }
  updateDialog(token, idDialog, data) {
    return this.apiService.updateDialog(token, idDialog, data);
  }
  updateDialogQuestion(token, idQuestion, data) {
    return this.apiService.updateDialogQuestion(token, idQuestion, data);
  }
  updateDialogAnswer(token, idAnswer, data) {
    return this.apiService.updateDialogAnswer(token, idAnswer, data);
  }
  updateDialogAnswerScene(token, idAnswer, data) {
    return this.apiService.updateDialogAnswerScene(token, idAnswer, data);
  }


  updateDialogAvatar(token, idDialog, data) {
    return this.apiService.updateDialogAvatar(token, idDialog, data);
  }
  updateFE(token, id, data) {
    return this.apiService.updateFE(token, id, data);
  }
  updateST(token, id, data) {
    return this.apiService.updateST(token, id, data);
  }
  updateName(token, id, data) {
    return this.apiService.updateName(token, id, data);
  }
  
  
  deleteDialogo(token, idDialog) {
    return this.apiService.deleteDialogo(token, idDialog);
  }
  deleteDialogoQuestion(token, idDialog) {
    return this.apiService.deleteDialogoQuestion(token, idDialog);
  }
  //Crear Accion de tipo pregunta
  getQuestions(token, idDialog) {
    return this.apiService.getQuestions(token, idDialog);
  }



  //GAME CONFIGURACION Y GENERAR JUEGO
  generateGamePrevisualizacion(token, id) {
    return this.apiService.generateGamePrevisualizacion(token, id);
  }
  generateGame(token, id) {
    return this.apiService.generateGame(token, id);
  }
  validarGame(token, id) {
    return this.apiService.valirarGame(token, id);
  }
  createClave(token, id, body) {
    return this.apiService.updateInfoGame(token, id, body);
  }
  updateImage(token, id, body) {
    return this.apiService.updateImage(token, id, body);
  }
  
  emailHelp(token, body) {
    return this.apiService.emailHelp(token, body);
  }

  //ACTION VIDEO
  deleteVideoAction(token, idaction){
    return this.apiService.deleteActionVideo(token, idaction);
  }
  updateUrlVideo(token, idaction, body){
    return this.apiService.updateUrlVideoAction(token, idaction, body);
  }
  //ACTION IMAGEN
  deleteImageAction(token, idaction){
    return this.apiService.deleteActionImage(token, idaction);
  }
  uploadImageAction(token, idaction, formdata) {
    return this.apiService.updateImageAction(token, idaction, formdata);
  }
  //ACTION AUDIO
  deleteAudioAction(token, idaction){
    return this.apiService.deleteActionAudio(token, idaction);
  }
  uploadAudioAction(token, idaction, formdata) {
    return this.apiService.updateAudioAction(token, idaction, formdata);
  }
  //ACTION SCENE FINAL
  getListSceneFinal(token, idgame){
    return this.apiService.getActionSceneFinal(token, idgame);
  }
  uploadImageSceneFinal(token, idscene, formdata) {
    return this.apiService.updateArchivoSceneFinal(token, idscene, formdata);
  }
  updateDataSceneFinal(token, id, data) {
    return this.apiService.updateDataSceneFinal(token, id, data);
  }
  updateSceneFinalAvatar(token, id, data){
    return this.apiService.updateSceneFinalAvatar(token, id, data);
  }
  deleteSceneFinal(token, idaction){
    return this.apiService.deleteActionEsceneFinal(token, idaction);
  }


  //MEMBERSHIP
  getPlanes(token,data){
    return this.apiService.getPlanes(token, data);
  }
  getKey(token,data){
    return this.apiService.getKey(token, data);
  }

}
